import BigNumber from 'bignumber.js'

const getPrefix = (value: BigNumber, withPlus?: boolean, withAbout = true) => {
  const about = withAbout ? '≈' : ''

  if (value.isZero()) {
    return '$'
  }
  if (value.isNegative()) {
    return `${about}-$`
  }
  if (withPlus) {
    return `${about}+$`
  }

  return `${about}$`
}

export const formatUsdValue = (
  valueUsd: BigNumber,
  withPlus?: boolean,
  withAbout?: boolean,
  withDp = true,
  zeroValue?: string,
  simplifyFormat?: boolean
) => {
  const prefix = getPrefix(valueUsd.dp(2), withPlus, withAbout)

  if (valueUsd.isZero()) {
    return zeroValue || `${prefix}0.0`
  }

  if (withDp) {
    if (simplifyFormat && valueUsd.isGreaterThanOrEqualTo(1000)) {
      return `${prefix}${valueUsd
        .dp(2)
        .abs()
        .dividedBy(1000)
        .integerValue(BigNumber.ROUND_DOWN)
        .toFormat(0, { suffix: 'k' })}`
    }
    return `${prefix}${valueUsd.dp(2).abs().toFormat()}`
  }

  if (simplifyFormat && valueUsd.isGreaterThanOrEqualTo(1000)) {
    return `${prefix}${valueUsd.abs().dividedBy(1000).integerValue(BigNumber.ROUND_DOWN).toFormat(0, { suffix: 'k' })}}`
  }

  return `${prefix}${valueUsd.abs().toFormat()}`
}
